import { Button, Form, Row, Space, theme } from "antd";
import FormItem, { createRegexRule, REGEX_EMAIL } from "../../form/form-item";
import { useCallback, useEffect } from "react";
import { useGetRelativesQuery } from "../../../../api/plamo-api";
import PlamoApiWithSaveNotifications from "../../util/with-save-notification";

import { DeleteOutlined } from "@ant-design/icons";
import { AdvancedForm, useAdvancedFormContext } from "../../form/advanced-form";

const { useCreateRelativeWithSaveNotificationMutation, useUpdateRelativeWithSaveNotificationMutation, useDeleteRelativeWithSaveNotificationMutation } = PlamoApiWithSaveNotifications;


const AddRelativeButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button onClick={onClick} disabled={advancedFormContext.readOnly}>
      Weiteren Angehörigen hinzufügen
    </Button>
  )
}

const DeleteButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button icon={<DeleteOutlined />} onClick={onClick} disabled={advancedFormContext.readOnly} />
  )
}

function CustomerRelatives({ customerId }) {
  const [form] = Form.useForm();
  const { data } = useGetRelativesQuery({ f: JSON.stringify({ "customer.id": { c: "EQ", v: customerId }}), st: JSON.stringify({ id: 'asc' }) }) as any
  const [ createRelative, { isLoading: isCreatingRelative } ] = useCreateRelativeWithSaveNotificationMutation();
  const [ updateRelative, { isLoading: isUpdatingRelative } ] = useUpdateRelativeWithSaveNotificationMutation();
  const [ deleteRelative, { isLoading: isDeletingRelative } ] = useDeleteRelativeWithSaveNotificationMutation();
  //const relatives = useMemo(() => data.items || [], [data])

  const isLoading = isCreatingRelative || isUpdatingRelative || isDeletingRelative;

  const { token } = theme.useToken();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  useEffect(() => {
      form.setFieldsValue(data)
  }, [form, data])

  const onFinish = useCallback(async (values: any) => {
    console.log('On finish', values);
    const promisesCreateUpdate = values.items.map(i => {
      console.log("Creating / updating relative", i);
      if(i.id) {
        return updateRelative(i);
      } else {
        return createRelative(i);
      }
    })

    const promisesDelete = data.items.filter(i => !values.items.find(i2 => i.id === i2.id)).map(i => deleteRelative(i));
    
    await Promise.all([...promisesCreateUpdate, ...promisesDelete]);
  }, [createRelative, updateRelative, deleteRelative, data]);

  return (<AdvancedForm form={form} name="relatives" style={formStyle} onFinish={onFinish} originalValues={data} isLoading={isLoading}>
    <Form.List name="items">
      {(fields, { add, remove }, { errors }) => <>{
        fields.map((field, index) => { return <>
          <Row><h3>Angehörige(r) { index + 1 } <DeleteButton  onClick={() => remove(index)} /></h3></Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="salutation" label="Anrede" type="backendEnum" typeData={{ ident: "salutation" }}/>
            <FormItem field={field} fieldName="firstName" label="Vorname" />
            <FormItem field={field} fieldName="lastName" label="Nachname" />
          </Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="addressStreet" label="Straße" />
            <FormItem field={field} fieldName="addressHouseNumber" label="Hausnummer" />
            <FormItem field={field} fieldName="addressZipCode" label="PLZ" rules={[createRegexRule(/^\d{5}$/, 'Keine gültige PLZ')]} />
            <FormItem field={field} fieldName="addressCity" label="Ort" />
            <FormItem field={field} fieldName="addressArea" label="Stadtteil" />
          </Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="phone" label="Festnetz" />
            <FormItem field={field} fieldName="mobile" label="Handy" />
            <FormItem field={field} fieldName="email" label="E-Mail" rules={[createRegexRule(REGEX_EMAIL, 'Keine gültige E-Mail-Adresse')]} />
            <FormItem field={field} fieldName="relation" label="Verhältnis" type="backendEnum" typeData={{ ident: "relativeRelation", allowCustomValue: true, }}/>
            <FormItem field={field} fieldName="legalRepresentative" label="Gesetzl. Vertreter" type="check" />
          </Row>
        </>})}
        <div style={{ textAlign: 'right', marginBottom: '24px', marginTop: '24px' }}>
          <Space size="small">
            <AddRelativeButton onClick={() => add({ customer: { id: customerId }})} />
          </Space>
        </div>
        </>
      }
    </Form.List> 
    </AdvancedForm>)
}

export default CustomerRelatives